import { useFeatureFlag } from '@ad-lucy/feature-flag-client-public';
import { useUser } from '@ad-lucy/gateway-provider';
import { isNonNullable } from '@modules/utils';
import { CampaignsNavBarMenu } from './CampaignsNavBarMenu';
import { CrmNavBarMenu } from './CrmNavBarMenu';
import NavBarItem from './NavBarItem';
import NavBarMenu from './NavBarMenu';
import { NavigationItem } from './nav.utils';

// Warning: changing the internal spacing of the elements of this component
// directly affects the sidebar animation
// e.g. changing the left or right padding/margin values
export function NavBar() {
  const user = useUser();
  const { enabled: isAssetsLibraryEnabled } = useFeatureFlag(
    'adc-mfe-assets-library',
  );
  const { enabled: isMediaPlanningEnabled } = useFeatureFlag(
    'mpfa-mfe-media-planning',
  );
  const { enabled: isAnalyticsEnabled } = useFeatureFlag(
    'reporting-analytics-mfe',
  );
  const { enabled: isClientReportingEnabled } = useFeatureFlag(
    'client-reporting-mfe',
  );
  const { enabled: isOrderManagementMfeEnabled } = useFeatureFlag(
    'order-management-mfe',
  );

  const children = [
    user.require('quickstart:view') ? (
      <NavBarItem
        key={NavigationItem.QUICKSTART}
        id={NavigationItem.QUICKSTART}
        name={NavigationItem.QUICKSTART}
        icon="IconFlash"
        paths={['/quickstart']}
        link="/quickstart"
      />
    ) : null,
    // Creatives are needed to show the card campaign image. In the future this might change
    // https://factor-eleven.atlassian.net/browse/AR-2214?focusedCommentId=129374
    user.require('campaign:view') ? (
      <CampaignsNavBarMenu key="campaigns" />
    ) : null,
    user.require('account:view') ? <CrmNavBarMenu key="crm" /> : null,
    isOrderManagementMfeEnabled && (
      <NavBarItem
        key={NavigationItem.ORDERS}
        id={NavigationItem.ORDERS}
        name={NavigationItem.ORDERS}
        icon="IconFileCheck"
        paths={['/orders/*']}
        link="/orders"
      />
    ),
    isOrderManagementMfeEnabled && (
      <NavBarItem
        key={NavigationItem.DOCUMENT_MANAGEMENT}
        id={NavigationItem.DOCUMENT_MANAGEMENT}
        name={NavigationItem.DOCUMENT_MANAGEMENT}
        icon="IconFileText"
        paths={['/document-management/*']}
        link="/document-management"
      />
    ),
    user.require('showroom:view') ? (
      <NavBarItem
        key={NavigationItem.SHOWROOM}
        id={NavigationItem.SHOWROOM}
        name={NavigationItem.SHOWROOM}
        icon="IconEye"
        paths={['/showroom/*']}
        link="/showroom"
      />
    ) : null,
    user.require('potential:view') ? (
      <NavBarItem
        key={NavigationItem.BOOKING_FORECAST}
        id={NavigationItem.BOOKING_FORECAST}
        name={NavigationItem.BOOKING_FORECAST}
        icon="IconMarkerPinLocated"
        paths={['/inventory-forecast/*']}
        link="/inventory-forecast"
      />
    ) : null,
    user.require('booking:view') ? (
      <NavBarItem
        key={NavigationItem.BOOKING_NEWCAMPAIGN}
        id={NavigationItem.BOOKING_NEWCAMPAIGN}
        name={NavigationItem.BOOKING_NEWCAMPAIGN}
        icon="IconRocket"
        paths={['/newcampaign/*']}
        link="/newcampaign"
      />
    ) : null,
    user.require('offer:view') ? (
      <NavBarItem
        key={NavigationItem.SALES}
        id={NavigationItem.SALES}
        name={NavigationItem.SALES}
        icon="IconBankNote"
        paths={['/sales/*']}
        link="/sales/board"
      >
        <NavBarMenu nested={true} itemCount={1}>
          <NavBarItem
            nested={true}
            id="sales_offer_creation_board"
            name={NavigationItem.OFFER_MANAGEMENT}
            icon="IconBankNote"
            paths={['/sales/*']}
            link="/sales/board"
          />
          {isMediaPlanningEnabled && (
            <NavBarItem
              nested={true}
              id={NavigationItem.MEDIA_PLANNING}
              name={NavigationItem.MEDIA_PLANNING}
              icon="IconAtom"
              paths={['/media-planning/*']}
              link="/media-planning"
            />
          )}
        </NavBarMenu>
      </NavBarItem>
    ) : null,
    user.require('analytics:view') && isAnalyticsEnabled ? (
      <NavBarItem
        key={NavigationItem.ANALYTICS}
        id={NavigationItem.ANALYTICS}
        name={NavigationItem.ANALYTICS}
        icon="IconActivity"
        paths={['/analytics/*']}
        link="/analytics"
      />
    ) : null,
    isAssetsLibraryEnabled ? (
      <NavBarItem
        key={NavigationItem.ASSETS_LIBRARY}
        id={NavigationItem.ASSETS_LIBRARY}
        name={NavigationItem.ASSETS_LIBRARY}
        icon="IconImage"
        paths={['/assets/*']}
        link="/assets"
      />
    ) : null,
    isClientReportingEnabled ? (
      <NavBarItem
        key={NavigationItem.CLIENT_REPORTING}
        id={NavigationItem.CLIENT_REPORTING}
        name={NavigationItem.CLIENT_REPORTING}
        icon="IconPresentationChart"
        paths={['/client-reporting/*']}
        link="/client-reporting"
      />
    ) : null,
  ].filter(isNonNullable);

  return <NavBarMenu>{children}</NavBarMenu>;
}
